var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 43.31" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "block-icon-featured-image"
    ),
    React.createElement(
      "g",
      { id: "Layer_2", "data-name": "Layer 2" },
      React.createElement(
        "g",
        { id: "Layer_1-2", "data-name": "Layer 1" },
        React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M44 7.28h-7.68L32 1.6A5.14 5.14 0 0 0 28.48 0h-9A5.14 5.14 0 0 0 16 1.6l-4.32 5.68H4a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4v-28a4 4 0 0 0-4-4zM24 38a13.3 13.3 0 1 1 13.3-13.3A13.3 13.3 0 0 1 24 38z" }),
        React.createElement("circle", { className: styles["cls-1"] || "cls-1", cx: "24", cy: "24.65", r: "8.8" })
      )
    )
  );
});